import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { useApproveReturn } from "../../../apis";
import { ConfirmApproveModalProps } from "./ConfirmApproveModal.types";

import styles from "./ConfirmApproveModal.module.scss";

export const ConfirmApproveModal = ({
  returnId,
  isOpen,
  onClose,
  refetchDetails,
  refetchReturns
}: ConfirmApproveModalProps) => {
  const { t } = useTranslation();

  const approve = useApproveReturn({
    onSuccess: () => {
      toast.success(t("Return has been successfully approved"));

      refetchDetails?.();
      refetchReturns();
      onClose();
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      title={t("Approve return")}
      isLoading={approve.isLoading}
      okText={t("Approve")}
      onOk={() => approve.mutate(returnId)}
      contentClassName={styles.confirmApproveModal}
      onClose={onClose}
    >
      <p className={styles.confirmApproveModal_text}>
        {t("Are you sure you want to approve this return?")}
      </p>
    </Modal>
  );
};
